import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Spinner } from '../components/Spinner';
import { useAuth } from './AuthProvider';

/** Only signed-in users with a staff or admin role get through. The rules enforce the same. */
export function RequireStaff({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') return <Spinner fullPage />;
  if (state.status === 'signedOut') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (!state.role) return <Navigate to="/no-access" replace />;
  return children;
}

/** Admins only, for staff account management. The staff API enforces the same. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  return (
    <RequireStaff>{state.role === 'admin' ? children : <Navigate to="/clients" replace />}</RequireStaff>
  );
}

/** Signed-in users only (any role), for the account page and the no-access page. */
export function RequireSignedIn({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  if (state.status === 'loading') return <Spinner fullPage />;
  if (state.status === 'signedOut') return <Navigate to="/login" replace />;
  return children;
}
